module.exports = __webpack_public_path__ + "img/联系客服.45a472bc.png";